module.exports = __webpack_public_path__ + "static/media/bg_mountain.4c84525a.jpg";